// Ported from video/scenes/lib/ease.ts.
export const clamp01 = (x: number) => (x < 0 ? 0 : x > 1 ? 1 : x);
export const clamp = (x: number, lo: number, hi: number) => (x < lo ? lo : x > hi ? hi : x);
export const lerp = (a: number, b: number, t: number) => a + (b - a) * t;
export const outCubic = (t: number) => 1 - Math.pow(1 - clamp01(t), 3);
export const inOutCubic = (t: number) => {
  const x = clamp01(t);
  return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
};
export const inQuad = (t: number) => clamp01(t) * clamp01(t);
export const outBack = (t: number, s = 1.4) => {
  const x = clamp01(t) - 1;
  return 1 + (s + 1) * x * x * x + s * x * x;
};
/** 0→1 as p moves across [a, b]. */
export const span = (p: number, a: number, b: number) => clamp01((p - a) / (b - a));
